import { render, staticRenderFns } from "./EditAttribute.vue?vue&type=template&id=51a91aac&scoped=true"
import script from "./EditAttribute.vue?vue&type=script&lang=js"
export * from "./EditAttribute.vue?vue&type=script&lang=js"
import style0 from "./EditAttribute.vue?vue&type=style&index=0&id=51a91aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a91aac",
  null
  
)

export default component.exports